import {
  ONBOARD_TENANT_REQUEST,
  ONBOARD_TENANT_SUCCESS,
  ONBOARD_TENANT_FAILURE,
  RESET_ONBOARD_TENANT_SUCCESS,
} from '../../../Constants/actionTypes';

import { onboardTenantApi } from '../../../Constants/apiService';

export const resetOnboardTenantSuccess = () => ({ type: RESET_ONBOARD_TENANT_SUCCESS });

/**
 * payload:
 * {
 *   bhomUrl: string,
 *   itsmUrl: string,
 *   key: string,
 *   secretKey: string,
 *   username: string,        // ✅ ITSM username
 *   password: string,        // ✅ ITSM password
 *   adminPassword: string | null // ✅ hannah_admin password
 * }
 */
export const onboardTenant = (payload) => async (dispatch, getState) => {
  dispatch({ type: ONBOARD_TENANT_REQUEST });

  const accessToken = getState()?.auth?.accessToken;

  try {
    const data = await onboardTenantApi(accessToken, payload);

    dispatch({
      type: ONBOARD_TENANT_SUCCESS,
      payload: data, // ✅ keep full backend response object
    });

    return data; // ✅ useful for caller
   } catch (error) {
    const isNetwork =
      error?.message === 'Failed to fetch' ||
      error?.message?.includes('NetworkError');

    const fallbackMessage = 'Server is currently down. Please try again later.';

    const payloadToStore = isNetwork
      ? { error: fallbackMessage }
      : (typeof error === 'object' && error !== null)
        ? error
        : { error: String(error || 'Something went wrong') };

    dispatch({
      type: ONBOARD_TENANT_FAILURE,
      payload: payloadToStore,
    });

    // ✅ IMPORTANT: don't throw object (causes [object Object] runtime overlay)
    return payloadToStore;
  }
};